<div id="container">
    <ng-container *ngFor="let violation of getViolations()">
        <div class="violation" [ngClass]="colorize(violation)" (click)="violationClicked.emit(violation); $event.stopPropagation()" [appViolationTooltip]="createViolationTooltipData(violation)">
            <div class="no-copy" [innerHTML]="getViolationSymbol(violation)"></div>
        </div>
    </ng-container>
</div>